import React from "react";
import { NavLink } from "react-router-dom";
import "./Footer.css"; // Ensure this file exists
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import logo from "../Assets/vlogo.png"; // Adjust the path to your logo

const Footer = () => {
    return (
        <>
            {/* Existing Footer */}
            {/* <footer className="footer"> */}
                {/* Our Company Section */}
                {/* <div className="footer-section">
                    <h3>Our Company</h3>
                    <NavLink to="/Overview" activeClassName="active">Overview</NavLink>
                    <NavLink to="/Team" activeClassName="active">Team</NavLink>
                    <NavLink to="/Blog" activeClassName="active">Blog</NavLink>
                    <NavLink to="/careers" activeClassName="active">Careers</NavLink>
                    <NavLink to="/Milestone" activeClassName="active">Our History</NavLink>
                </div> */}

                {/* Technologies Section */}
                {/* <div className="footer-section technologies">
                    <h3>Technologies</h3>
                    <NavLink to="/network">Network</NavLink>
                    <NavLink to="/Wired">Wired</NavLink>
                    <NavLink to="/Radio">RF (Radio Frequency)</NavLink>
                    <NavLink to="/core">Core</NavLink>
                </div> */}

                {/* Solutions Section - Two Columns */}
                {/* <div className="footer-section solutions-section">
                    <h3>Solutions</h3>
                    <div className="solutions-grid">
                        <div className="solutions-column">
                            <NavLink to="/Fuel monitoring">Fuel Monitoring System</NavLink>
                            <NavLink to="/Battery management">Battery Management Systems</NavLink>
                            <NavLink to="/Person tracking system">Asset Tracking/Person Tracking System</NavLink>
                            <NavLink to="/Retrofit AMR solutions">Retrofit AMR Solution</NavLink>
                            <NavLink to="/Prepaid meter solution">Prepaid Meter Solution</NavLink>
                            <NavLink to="/Street light control">Street Light Control</NavLink>
                            <NavLink to="/Vehicle Tracking System">Vehicle Tracking System</NavLink>
                            <NavLink to="/Weather Monitoring">Weather Monitoring</NavLink>
                            <NavLink to="/Aqua">AQUA</NavLink>
                            <NavLink to="/Water quality management solution">Water Quality Management Solution</NavLink>
                        </div>
                        <div className="solutions-column">
                            <NavLink to="/Energy monitoring system">Energy Monitoring System</NavLink>
                            <NavLink to="/Visitor management">Visitor Management</NavLink>
                            <NavLink to="/Water supply management solution">Water Supply Management Solution</NavLink>
                            <NavLink to="/Data transfer unit">Data Transfer Unit</NavLink>
                            <NavLink to="/Remote gateway unit">Remote Gateway Unit</NavLink>
                            <NavLink to="/Food chain industries">Food Chain Industry</NavLink>
                            <NavLink to="/Fire detection">Fire Detection</NavLink>
                        </div>
                    </div>
                </div> */}

                {/* Product Section */}
                {/* <div className="footer-section">
                    <h3>Product</h3>
                    
                    <NavLink to="/fuel-and-fleet-management" activeClassName="active">A Fuel and Fleet Management System</NavLink>
                    <NavLink to="/remote-gateways" activeClassName="active">Remote Gateways</NavLink>
                    <NavLink to="/rfid-tag" activeClassName="active">RFID Tag</NavLink>
                    <NavLink to="/RFID Reader" activeClassName="active">RFID Reader</NavLink>
                    <NavLink to="/Asset Monitoring System" activeClassName="active">Asset Monitoring System</NavLink>
                    <NavLink to="/Metro Water Quality" activeClassName="active">Metro Water Quality</NavLink>
                    <NavLink to="/Burgular Alarm System" activeClassName="active">Burgular Alarm System</NavLink>
                    <NavLink to="/RF Based Temperature Monitoring For Truck" activeClassName="active">RF Based Temperature Monitoring For Truck</NavLink>
                    <NavLink to="/Temperature Monitoring For Cold Storage" activeClassName="active">Temperature Monitoring For Cold Storage</NavLink>
                    <NavLink to="/Temperature Monitoring For Food and Transport" activeClassName="active">Temperature Monitoring For Food and Transport</NavLink>
                    <NavLink to="/lora-based-water-meter" activeClassName="active">LoRa Based Water Meter</NavLink>
                </div> */}
            {/* </footer> */}

            <div className="footer-legal">
    <div className="footer-legal-content">
        <img src={logo} alt="TCS Logo" className="footer-logo" />
        <p>©2025 VAJRA IOT PRIVATE Limited</p>
        {/* <div className="legal-links">
            <NavLink to="/privacy-notice">Privacy Notice</NavLink>
            <NavLink to="/cookie-policy">Cookie Policy</NavLink>
            <NavLink to="/accessibility-declaration">Accessibility Declaration</NavLink>
            <NavLink to="/disclaimer">Disclaimer</NavLink>
            <NavLink to="/security-policy">Security Policy</NavLink>
            <NavLink to="/california-notice">California Notice at Collection</NavLink>
        </div> */}
        <div className="social-icons">
            <a href="https://www.instagram.com/vajra_iot/?igsh=NnViZmYyOXAwOHh2#" target="_blank" rel="noopener noreferrer">
                <FaInstagram style={{ color: "#E1306C" }} />
            </a>
            <a href="https://www.facebook.com/vajraiot/" target="_blank" rel="noopener noreferrer">
                <FaFacebook style={{ color: "#1877F2" }} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <FaTwitter style={{ color: "#1DA1F2" }} />
            </a>
            <a href="https://www.linkedin.com/in/vajra-iot-pvt-ltd-b84a14195/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin style={{ color: "#0077B5" }} />
            </a>
        </div>
    </div>
</div>
        </>
    );  
};

export default Footer;